import { arrayToForm } from '../../../web-app-components/utils/formInputs';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

/**
 * Map Strapi PrizeImages to FilesField shape (same pattern as routes Images).
 */
export const prizeImagesToForm = (PrizeImages) =>
  arrayToForm(PrizeImages || []).map(({ id, documentId, name, ext, formats, url: pictureUrlFallback }) => ({
    id: id ?? documentId,
    name: `${name || ''}${ext || ''}`,
    url: `${SERVER_URL}${formats?.thumbnail?.url || formats?.small?.url || pictureUrlFallback || ''}`,
  }));
